// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"NoResults_messageContainer__5ZL7a"};